<template>
  <div class="ud-input">
    <input
      v-model="modelValue"
      v-bind="$attrs"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur"
      ref="input"
    >
  </div>
</template>

<script>
export default {
  name: 'UdInput',
  inheritAttrs: false,
  props: {
    value: null,
    center: Boolean // 文字是否置中
  },
  computed: {
    modelValue: {
      get(){ return this.value == null ? "" : this.value },
      set(val){ this.$emit('input', val) }
    },
  },
  mounted() {
    if(this.center) this.$refs.input.style.textAlign = 'center';
  },
  methods: {
    onInput() {
      this.$parent.$emit('validate'); // 通知FormItem校驗
    },
    onFocus() {
      this.$emit('focus');
    },
    onBlur() {
      this.$emit('blur');
    },
    focus() {
      this.$refs.input.focus();
    }
  }
}
</script>

<style>
.ud-input input {
  appearance: none;
  width: 100%;
  padding: 5px 10px;
  min-height: 48px;
  font-size: 14px;
  color: #000;
  border: 1px solid #9e9e9f;
  border-radius: 10px;
  background-color: #fff;
  transition: all 0.2s ease; }
  .ud-input input::placeholder {
    color: #aaa; }
  .ud-input input:focus {
    outline: 0;
    border: 1px solid #000; }
  .ud-input input:disabled {
    background-color: #efefef;
    cursor: not-allowed; }
</style>
